import gql from 'graphql-tag';

export const GET_SUPERVISOR_AND_AREA_DATA = gql`
  query ($entryYear: String!, $department: String!) {
    researchAreasAndSupervisors(
      input: { entryYear: $entryYear, department: $department }
    ) {
      researchAreas
      proposedSupervisors {
        label
        value
      }
    }
  }
`;
